import ApiService from "@/common/api/api.service";

let endpoint = "Projeto";

const Entregavel = {
  setEndpoint(endpointSelecionado) {
    endpoint = endpointSelecionado;
  },

  aprovarEntregavel(id) {
    return ApiService.put(`Projeto/aprovar-entregavel?id=${id}`);
  },

  salvarEntregavel(form) {
    if (form.previsto) {
      return ApiService.put(`${endpoint}/realizar-entregavel`, form);
    } else {
      if (form.mesRealizado) form.prazo = form.mesRealizado;
      return new Promise((resolve, reject) => {
        let api = null;

        if (form.id) {
          api = ApiService.put(`${endpoint}/entregavel`, form);
        } else {
          api = ApiService.post(`${endpoint}/entregavel`, form);
        }

        api
          .then((res) => {
            if (!form.id) form.id = res.data.data;

            ApiService.put(`${endpoint}/realizar-entregavel`, form)
              .then(() => {
                resolve();
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },

  listarEntregaveis(id) {
    return ApiService.get(`${endpoint}/entregavel?projetoId=${id}`);
  },

  uploadEntregavel(form) {
    return ApiService.put(`${endpoint}/adicionar-arquivo-entregavel`, form);
  },

  downloadEntregavel(id) {
    return ApiService.downloadFile(`${endpoint}/download-arquivo-entregavel?id=${id}`);
  },

  removerEntregavel(id) {
    return ApiService.delete(`${endpoint}/entregavel?id=${id}`);
  },
  removerArquivoVersionado(id) {
    return ApiService.delete(`${endpoint}/remover-arquivo-entregavel?id=${id}`);
  }
};

export default Entregavel;
